export default __webpack_public_path__ + "f11bc275673b9a81119a2b67db48fc1d.jpg";